import './App.css';
import Navbar from './Components/Navbar/Navbar.jsx';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import React, { Suspense, useState } from 'react';
import Footer from './Components/Footer/Footer.jsx';
import ShopContextProvider from './Context/ShopContext.jsx';
import Blog_Note_Book from './Components/Assets/Blog_Note_Book.png';
import aboutus_banner from './Components/Assets/aboutus_banner.png';
import banner_snacks from './Components/Assets/banner_snacks.png';
import banner_spices from './Components/Assets/banner_spices.png';
import banner_drinks from './Components/Assets/banner_drinks.png';
import banner_condiment from './Components/Assets/banner_condiment.png';
import CartItems from './Components/CartItems/CartItems.jsx';
import Success from './Pages/Success.jsx';



const ShopCategory = React.lazy(() => import('./Pages/ShopCategory.jsx'));
const Shop = React.lazy(() => import('./Pages/Shop.jsx'));
const ProductPage = React.lazy(() => import('./Pages/Product.jsx'));
const Cart = React.lazy(() => import('./Pages/Cart.jsx'));
const LoginSignup = React.lazy(() => import('./Pages/LoginSignup.jsx'));
const Blog = React.lazy(() => import('./Pages/Blog.jsx'));

function DynamicShopCategory() {
  const { category } = useParams();
  const bannerMap = { spices: banner_spices, snacks: banner_snacks, drinks: banner_drinks, condiment_jam: banner_condiment };
  const banner = bannerMap[category] || Blog_Note_Book;

  return (
    <Suspense fallback={<div>Loading Category...</div>}>
      <ShopCategory banner={banner} category={category} />
    </Suspense>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo?.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

//Cart component


function App() {

  return (
    <BrowserRouter>
      <ShopContextProvider>

        <Navbar />


        <ErrorBoundary>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Shop />} />
              <Route path="/about" element={<ShopCategory banner={aboutus_banner} category="about" />} />
              <Route path="/blog" element={<Blog />} />

              <Route path="/spices" element={<ShopCategory banner={banner_spices} category="spices" />} />
              <Route path="/snacks" element={<ShopCategory banner={banner_snacks} category="snacks" />} />
              <Route path="/drinks" element={<ShopCategory banner={banner_drinks} category="drinks" />} />
              <Route path="/condiment_jam" element={<ShopCategory banner={banner_condiment} category="Condiment & Jam" />} />

              <Route path="/category/:category" element={<DynamicShopCategory />} />

              <Route path="/product/:productId" element={<ProductPage />} />
              <Route path="/addtocart" element={<CartItems />} />




              <Route path="/" element={<Shop />} />
              <Route
                path="/product/:productId"
                element={<ProductPage />}
              />

              <Route path="/cart" element={<CartItems />} />
              <Route path="/cart-items" element={<CartItems />} />
              <Route path="/login" element={<LoginSignup />} />
              <Route path="/success" element={<Success />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>

        <Footer />


      </ShopContextProvider>
    </BrowserRouter>
  );
}

export default App;